import React, { useState } from 'react'
import { Col, FormGroup } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'

import { DatePicker } from 'components/DatePicker'
import { SelectWithLabel } from 'components/Form'

const SelectAdvanced = ({ colType, name, defaultValue, colIndex, colValue, onChange, options, md }) => {
  const defaultDate = colType === 'date' && defaultValue ? moment(defaultValue.label) : null
  const [dateSelected, setDateSelected] = useState(defaultDate)

  const onChangeDate = (date) => {
    setDateSelected(date)
    onChange(date, colIndex)
  }

  switch (colType) {
    case 'date': {
      return (
        <Col md='2' key={colIndex}>
          <FormGroup inline>
            <DatePicker
              id={`id${colIndex}`}
              value={colValue.length ? dateSelected : null}
              name={name}
              onDateChange={onChangeDate}
              isOutsideRange={() => false}
              displayFormat={'DD/MM/YYYY'}
            />
          </FormGroup>
        </Col>
      )
    }
    default:
      return (
        <FormGroup inline>
          <SelectWithLabel
            key={`key_${colValue}`}
            id={`key_${colValue}`}
            name={name}
            options={options}
            onChange={onChange}
            iconAlt
            classNameWrapper={'filters-advance'}
            value={defaultValue}
            placeholder={I18n.t('dashboard_select')}
          />
        </FormGroup>
      )
  }
}

export default SelectAdvanced
